import React from 'react';

import Header from '../components/Header'
import Footer from '../components/Footer'
import DocSvc from '../components/DocSvc'
import MainNavigation from '../components/MainNavigation'

export default (props) => (
    <div>
        <Header></Header>
        <MainNavigation></MainNavigation>
        <DocSvc></DocSvc>
        <Footer></Footer>
    </div>
)
